import React, { useCallback, useState, useRef, useEffect } from "react";

import { useNavigate, useParams } from "react-router-dom";

import slugify from "slugify";
import {
  Button,
  Form,
  Input,
  Modal,
  Select,
  Space,
  Divider,
  Card,
  Row,
  Col,
  Switch,
  TreeSelect,
} from "antd";

import {
  AiFillCheckCircle,
  AiFillCloseSquare,
  AiFillEdit,
} from "react-icons/ai";

import { Editor } from "@tinymce/tinymce-react";
import ENV from "../../consts/config";
import FileChonky from "../../components/chonky/index";
import ReactDOM from "react-dom";
import products from "../../components/plugins/selectProduct";
import UploadFile from "../../components/UploadFile";
import Swal from "sweetalert2";
import { fileManagerActions, systemActions } from "../../store";
import { useSelector, useDispatch } from "react-redux";

import blogApi from "../../api/blog/blogApi";
import categoryApi from "../../api/blog/categoryApi";
import { list_to_tree } from "../../utils/index";
import parse from "html-react-parser";
import ProductsModal from "../../components/ProductsModal";
import { CheckNullParams } from "../../utils/CheckNullParams";
import UpFileSingleProp from "../../components/UpFileSingleProp";

const ArticleEdit = (props) => {
  let { id } = useParams();
  const dispatch = useDispatch();

  let navigate = useNavigate();
  const goToPreviousPath = () => {
    navigate(-1);
  };

  const back = () => {
    confirm({
      title: "Mọi chỉnh sửa sẽ bị mất ! Tiếp tục quay lại?",
      onOk() {
        goToPreviousPath();
      },
      onCancel() {},
    });
  };
  const { user: authUser } = useSelector((x) => x.auth);

  const { TextArea } = Input;
  const contentRef = useRef(null);
  const descriptionRef = useRef(null);

  const confirm = Modal.confirm;
  const { Option } = Select;
  const [form] = Form.useForm();

  const [valueForm, setValueForm] = useState({});
  const [description, setDescription] = useState("");
  const [content, setContent] = useState("");
  const [valueCate, setValueCate] = useState(null);
  const [typeSubmit, setTypeSubmit] = useState();

  const [productSelects, setProductSelects] = useState([]);

  const [listProductSelect, SetListProductSelect] = useState([]);

  const [categorySelect, setCategorySelect] = useState([]);
  const [categoryNoFilter, setCategoryNoFilter] = useState([]);


  const [image, setImage] = useState(null);

  const onUploadImage = (url) => {
    setImage(url);
  };

  const { fileImageUrl } = useSelector((x) => x.fileManager);

  const setImageNull = (url) => {
    dispatch(fileManagerActions.setUrlImageUp(url));
  };

  useEffect(() => {
    getCategorySelect();
  }, []);

  useEffect(() => {
    if (categoryNoFilter.length > 0) {
      getBlog(id);
    }
  }, [categoryNoFilter]);

  const setLoading = (status) => {
    dispatch(systemActions.setLoadingSystem(status));
  };

  const getBlog = (id) => {
    blogApi
      .getBlog(id)
      .then((res) => {
        if (res) {
          const data = {
            title: res.title,
            published: res.published,
            slug: res.slug,
            description: res.description,
            content: res.content,
            seoTitle: res.seoTitle,
            seoDescription: res.seoDescription,
            seoKeywords: res.seoKeywords,
            productTitle: res.productTitle,
          };

          if (res?.products.length > 0) {
            const _products = res.products.map((item) => {
              return { id: item.id, name: item.name };
            });
            setProductSelects(_products);
          }

          if (res?.description) {
            setDescription(parse(res?.description));
          }
          if (res?.content) {
            let _content = parse(res?.content || "");
            _content = _content.replaceAll(
              `${ENV.IMAGE_VARIABLE}`,
              `${ENV.CDN_URL}`
            );
            setContent(_content);
          }

          const check =
            categoryNoFilter.filter((x) => x.id === res.category).length || 0;

          if (check > 0) {
            setValueCate(res.category);
          }
          form.setFieldsValue(data);
          setImageNull(res.avatar);
          setImage(res.seoImage);
          setLoading(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  const getCategorySelect = () => {
    setLoading(true);
    const params = { display: true, page: 1, limit: 10000 };
    categoryApi
      .getCategories(params)
      .then((res) => {
        if (res) {
          const cate = res?.results.map((item) => {
            return {
              title: item.name,
              value: item.id,
              id: item.id,
              parentId: item.parent?.id || "0",
              parentName: item.parent?.name || "",
              children: null,
            };
          });

          setCategoryNoFilter(cate);
          const list = list_to_tree(cate);
          setCategorySelect(list);
        } else {
          setLoading(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  const titleChange = useCallback(
    (values) => {
      const slug = slugify(values).toLowerCase();
      form.setFieldsValue({
        slug: slug,
      });
    },
    [form]
  );

  const onChangeCategory = (newValue) => {
    setValueCate(newValue);
  };

  const showBox = (callback, value, meta) => {
    const ModalFile = (props) => {
      const [show, setShow] = useState(true);
      const [image, setImage] = useState();
      useEffect(() => {}, []);
      const onSelected = (data) => {
        setImage(data);
      };
      const onAction = () => {
        document.querySelector(".tox .tox-dialog-wrap").style.display = "";
        ReactDOM.unmountComponentAtNode(props.modal);
      };
      return (
        <>
          <Modal
            title=""
            visible={show}
            width={1300}
            style={{ top: 20 }}

            onOk={() => {
              setShow(false);
              props.callback(`${ENV.CDN_URL}${image}`);
              onAction();
            }}
            okButtonProps={{
              disabled: !image,
            }}
            onCancel={() => {
              setShow(false);
              onAction();
            }}
            destroyOnClose={true}
          >
            {authUser ? (
              <div style={{ padding: "15px" }}>
                <style>
                  {`.ant-modal-wrap{
            z-index: 1300
          } .ant-image-preview-wrap{z-index: 1301}`}
                </style>
                <FileChonky onSelected={onSelected} />
                <br />
              </div>
            ) : null}
          </Modal>
        </>
      );
    };
    const modal = document.createElement("span");
    document.querySelector(".tox .tox-dialog-wrap").style.display = "none";
    ReactDOM.render(<ModalFile modal={modal} callback={callback} />, modal);
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const onFinish = (values) => {
    if (valueCate == null) {
      Swal.fire({
        title: "Thất bại!",
        text: "Vui lòng chọn chuyên mục!",
        icon: "warning",
        confirmButtonText: "OK",
      });
      return;
    }

    updateBlog(values);
  };

  const updateBlog = (data) => {
    setLoading(true);

    let description = "";
    if (descriptionRef.current) {
      description = descriptionRef.current.getContent() || "";
    }

    let content,
      contentNonHtml = "";

    if (contentRef.current) {
      let _content = contentRef.current.getContent() || "";

      if (_content !== "") {
        _content = _content.replaceAll(`${ENV.CDN_URL}`, `${ENV.IMAGE_VARIABLE}`);
      }

      let _contentNonHtml =
        contentRef.current.getContent({ format: "text" }) || "";

      if (_contentNonHtml !== "") {
        _contentNonHtml = _contentNonHtml.replaceAll(
          `${ENV.CDN_URL}`,
          `${ENV.IMAGE_VARIABLE}`
        );
      }
      content = _content;
      contentNonHtml = _contentNonHtml;
    }

    const payload = {
      title: data.title,
      published: data.published,
      slug: data.slug,
      description: description,
      seoImage : image,
      seoTitle: data.seoTitle,
      seoDescription: data.seoDescription,
      seoKeywords: data.seoKeywords,
      content: content,
      contentNonHtml: contentNonHtml,
      avatar: fileImageUrl ? fileImageUrl : null,
      category: valueCate,
      productTitle: data.productTitle,
      products: listProductSelect.length > 0 ? listProductSelect : null,
    };

    const payload_final = CheckNullParams(payload);

    blogApi.updateBlog(id, payload_final).then(
      (res) => {
        if (!res.code) {
          Swal.fire({
            title: "Thành Công!",
            text: "Sửa thành công!",
            icon: "success",
            confirmButtonText: "OK",
          });
          if (typeSubmit === "SAVE") {
            setLoading(false);
            goToPreviousPath();
            return;
          }
          getBlog(id);
        } else {
          Swal.fire({
            title: "Thất bại!",
            text: res.message,
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      },
      (err) => {
        // console.log("err", err);
        setLoading(false);
        Swal.fire({
          title: "Thất bại!",
          text: err.response?.data?.message,
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    );
  };

  const submitForm = (type) => {
    if (type === "SAVE") {
      setTypeSubmit(type);
    } else {
      setTypeSubmit(type);
    }
    form.submit();
  };

  const [treeLine, setTreeLine] = useState(true);
  const [showLeafIcon, setShowLeafIcon] = useState(false);

  const onSelectProducts = (data) => {
    const _data = data.map((item) => {
      return item.id;
    });

    SetListProductSelect(_data);
  };

  return (
    <>
      <Row gutter={[24, 24]}>
        <Col span={24} md={24} className="mb-24">
          <Card
            className="header-solid h-full"
            bordered={false}
            title={<h6 className="font-semibold m-0">Chỉnh sửa bài viết </h6>}
            extra={
              <>
                <Space>
                  <Button
                    type="primary"
                    icon={<AiFillCheckCircle />}
                    onClick={() => {
                      submitForm("SAVE");
                    }}
                  >
                    &nbsp;Lưu
                  </Button>
                  <Button
                    icon={<AiFillEdit />}
                    onClick={() => {
                      submitForm("SAVE_EDIT");
                    }}
                  >
                    &nbsp;Lưu và tiếp tục sửa
                  </Button>

                  <Button
                    type="danger"
                    icon={<AiFillCloseSquare />}
                    onClick={() => {
                      back();
                    }}
                  >
                    &nbsp;Hủy
                  </Button>
                </Space>
              </>
            }
            bodyStyle={{ paddingTop: "0" }}
          >
            <Divider />
            <Form
              form={form}
              initialValues={valueForm}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              labelCol={{
                span: 2,
              }}
              layout="horizontal"
              size="large"
            >
              <Form.Item
                tooltip="Trạng thái đăng tải của bài viết"
                label="Published"
                name="published"
                valuePropName="checked"
              >
                <Switch />
              </Form.Item>

              <Form.Item
                label={
                  <label>
                    <span style={{ color: "#ff4d4f" }}>*</span> Chuyên mục
                  </label>
                }
              >
                <TreeSelect
                  allowClear
                  treeLine={
                    treeLine && {
                      showLeafIcon,
                    }
                  }
                  style={{
                    width: "100%",
                  }}
                  dropdownStyle={{
                    maxHeight: 400,
                    overflow: "auto",
                  }}
                  value={valueCate}
                  treeData={categorySelect}
                  treeDefaultExpandedKeys={[valueCate]}
                  onChange={onChangeCategory}
                  placeholder="Chọn chuyên mục"
                />

                <br />
              </Form.Item>

              <Form.Item
                label="Tên bài viết"
                name="title"
                tooltip="Tên hiển thị của bài viết"
                onChange={(e) => {
                  titleChange(e.target.value);
                }}
                rules={[
                  {
                    required: true,
                    message: "Vui lòng nhập!",
                  },
                ]}
              >
                <Input />
              </Form.Item>

              <Form.Item>
                <Row>
                  <Col span={8}>
                    <Form.Item
                      label="Ảnh đại diện"
                      tooltip="Ảnh hiển thị trên website"
                    >
                      <UploadFile />
                    </Form.Item>
                  </Col>

                  <Col span={8}>
                    <Form.Item
                      label="Ảnh Thumbnail"
                      tooltip="Ảnh hiển thị trên social"
                    >
                      <UpFileSingleProp
                        onUploadImage={onUploadImage}
                        image={image}
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </Form.Item>


              <Form.Item label="Thẻ tiêu đề" name="seoTitle">
                <Input />
              </Form.Item>

              <Form.Item label="Mô tả meta" name="seoDescription">
                <TextArea rows={4} />
              </Form.Item>

              <Form.Item label="Từ khóa meta" name="seoKeywords">
                <Input />
              </Form.Item>

              <Form.Item
                label="Slug"
                name="slug"
                rules={[
                  {
                    pattern: new RegExp(/^[a-z0-9]+(?:-[a-z0-9]+)*$/),
                    message: "Slug không đúng định dạng!",
                  },
                  {
                    required: true,
                    message: "Thiếu dữ liệu!",
                  },
                ]}
              >
                <Input />
              </Form.Item>

              {/* <Form.Item label="Ảnh đại diện" name="avatar">
                <UploadFile />
              </Form.Item> */}

              <Form.Item
                label="Mô tả ngắn"
                tooltip="Mô tả rút gọn của bài viết"
              >
                <Editor
                  tinymceScriptSrc={
                    process.env.PUBLIC_URL + "/tinymce/tinymce.min.js"
                  }
                  onInit={(evt, editor) => (descriptionRef.current = editor)}
                  initialValue={description}
                  init={{
                    height: 300,
                    menubar: false,
                    language: "vi",
                    plugins: [
                      "advlist",
                      "autolink",
                      "lists",
                      "link",
                      "charmap",
                      "preview",
                      "anchor",
                      "searchreplace",
                      "visualblocks",
                      "code",
                      "fullscreen",
                      "insertdatetime",
                      "media",
                      "table",
                      "help",
                      "wordcount",
                    ],
                    // apiKey: "5GMJDFLT",
                    toolbar:
                      "undo redo | blocks | " +
                      "bold italic forecolor | alignleft aligncenter " +
                      "alignright alignjustify | bullist numlist outdent indent | " +
                      "removeformat | help",
                    content_style:
                      "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
                  }}
                />
              </Form.Item>

              <Form.Item label="Nội dung" tooltip="Nội dung của bài viết">
                <Editor
                  tinymceScriptSrc={
                    process.env.PUBLIC_URL + "/tinymce/tinymce.min.js"
                  }
                  onInit={(evt, editor) => (contentRef.current = editor)}
                  initialValue={content}
                  init={{
                    height: 600,
                    menubar: true,
                    image_title: true,
                    relative_urls: false,
                    remove_script_host: true,
                    document_base_url: "/",
                    file_picker_callback: showBox,
                    file_picker_types: "image",
                    language: "vi",
                    plugins: [
                      "advlist",
                      "autolink",
                      "lists",
                      "link",
                      "image",
                      "charmap",
                      "preview",
                      "anchor",
                      "searchreplace",
                      "visualblocks",
                      "code",
                      "fullscreen",
                      "insertdatetime",
                      "media",
                      "table",
                      "help",
                      "wordcount",
                      "myCustomToolbarButton",
                    ],
                    setup: function (options) {
                      window.tinymce.PluginManager.add(
                        "myCustomToolbarButton",
                        products
                      );
                    },
                    toolbar:
                      "undo redo | productButton | link image | blocks | " +
                      "bold italic forecolor | alignleft aligncenter " +
                      "alignright alignjustify | bullist numlist outdent indent | " +
                      "removeformat | help",
                    content_style:
                      "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
                    extended_valid_elements: "product[id]",
                    custom_elements: "product",
                    object_resizing: ":not(.iframe-product)",
                  }}
                />
              </Form.Item>

              <Form.Item
                label="Tiêu đề sản phẩm"
                name="productTitle"
                tooltip="Tiêu đề hiển thị trên danh sách sản phẩm"
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="Sản phẩm"
                tooltip="Sản phẩm hiển thị cùng bài viết"
                name="products"
              >
                <ProductsModal
                  productItems={productSelects}
                  onSelectProducts={onSelectProducts}
                />
              </Form.Item>
            </Form>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default ArticleEdit;
